module.exports = __webpack_public_path__ + "陈细明-da68d25d.png";